// utils/dateFormatter.js
export function formatDate(dateStr) {
  // Ensure the input is a string
  if (typeof dateStr !== "string") {
    throw new TypeError("Input must be a string in YYYY-MM-DD format");
  }

  // Parse the input into a Date object
  const date = new Date(dateStr);

  // Options for formatting
  const options = {
    weekday: "short",   // Tue
    year: "numeric",    // 2026
    month: "short",     // May
    day: "2-digit"      // 07
  };

  // Format using Intl.DateTimeFormat
  return new Intl.DateTimeFormat("en-US", options).format(date);
}

export function formatToLocalDateTime(utcString) {
  // Parse the UTC string into a Date object
  const date = new Date(utcString);

  // Use Intl.DateTimeFormat for local timezone conversion
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  // Format according to the client’s local timezone
  const formatter = new Intl.DateTimeFormat(undefined, options);
  const parts = formatter.formatToParts(date);

  // Extract parts for custom formatting
  const year = parts.find(p => p.type === "year").value;
  const month = parts.find(p => p.type === "month").value;
  const day = parts.find(p => p.type === "day").value;
  const hour = parts.find(p => p.type === "hour").value;
  const minute = parts.find(p => p.type === "minute").value;
  const dayPeriod = parts.find(p => p.type === "dayPeriod").value;

  // Return in desired format: YYYY-MM-DD hh:mmAM/PM
  return `${year}-${month}-${day} ${hour}:${minute}${dayPeriod}`;
}

export function formatToLocalDate(utcString) {
  // Parse the UTC string into a Date object
  const date = new Date(utcString);

  // Use Intl.DateTimeFormat for local timezone conversion
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  // Format according to the client’s local timezone
  const formatter = new Intl.DateTimeFormat(undefined, options);
  const parts = formatter.formatToParts(date);

  // Extract parts for custom formatting
  const year = parts.find(p => p.type === "year").value;
  const month = parts.find(p => p.type === "month").value;
  const day = parts.find(p => p.type === "day").value;
  
  // Return in desired format: YYYY-MM-DD hh:mmAM/PM
  return `${year}-${month}-${day}`;
}